// extracted by mini-css-extract-plugin
export default {"header":"Subheader_header__29Gm8","profile":"Subheader_profile__g7pSR","titleContainer":"Subheader_titleContainer__1JOnA"};